import React, { createContext } from "react";

export const AppContext = createContext("appState");

export const AppContextProvider = (props: React.PropsWithChildren<{}>) => {
  return (
    <AppContext.Provider value="asdasd">{props.children}</AppContext.Provider>
  );
};

export default AppContext;
